/**
 * bindMatchEndPostGame — Wire rematch / lobby return into match-end UI (SPY-215).
 */

/**
 * @param {{
 *   matchEndUi?: { bindPostGame?: Function },
 *   lobbyController?: { showLobby?: Function },
 *   lobbySession?: { getMatchConfig?: Function },
 *   matchRuntime?: { mapId?: string },
 *   loadLiveMap?: (mapId: string) => void,
 *   switchChampion?: (id: string) => void,
 *   applyLobbySpells?: (cfg: object) => void
 * }} deps
 */
export function bindMatchEndPostGame({
  matchEndUi,
  lobbyController,
  lobbySession,
  matchRuntime,
  loadLiveMap,
  switchChampion,
  applyLobbySpells
} = {}) {
  if (!matchEndUi || typeof matchEndUi.bindPostGame !== 'function') return null;
  return matchEndUi.bindPostGame({
    onReturnLobby: () => {
      if (lobbyController && typeof lobbyController.showLobby === 'function') {
        lobbyController.showLobby();
      }
    },
    onRematch: () => {
      const cfg = lobbySession?.getMatchConfig?.();
      const mapId = cfg?.mapId || matchRuntime?.mapId;
      if (mapId && typeof loadLiveMap === 'function') loadLiveMap(mapId);
      if (cfg?.championId && typeof switchChampion === 'function') {
        switchChampion(cfg.championId);
      }
      if (cfg && typeof applyLobbySpells === 'function') applyLobbySpells(cfg);
    }
  });
}
